<template>
  <div class="confirm-deactivate lg:-mt-2">
    <div
      class="flex gap-32 max-w-768 mx-auto py-32 sm:py-64 md:px-16 items-center content-center lg:max-w-1120 lg:gap-112 lg:items-start"
    >
      <Card class="max-w-448 mx-auto z-[1] md:box-shadow-md md:bg-white md:p-24">
        <h1 class="text-h3 md:text-h2">Your account is deactivated</h1>
        <p class="text-body mt-8">Thank you for using Sittercity</p>
        <div v-if="hasActiveIapSubscription">
          <p class="text-strong-body mt-16">Your iOS Premium Membership will remain active unless you cancel it through Apple.</p>
          <Button
            value="Manage Apple Subscription"
            variant="outlined"
            size="medium"
            class="w-full mt-24"
            href="https://apps.apple.com/account/subscriptions"
          />
        </div>
        <p v-if="hasPremiumWebSubscription" class="text-small mt-16">Your premium membership has been ended.</p>
        <h2 class="text-strong-body mt-32 pt-32 border-t-1 border-solid border-grey-divider-subdued">Change your mind?</h2>
        <p class="text-small mt-8">
          When you’re ready to come back you can reactivate your Sittercity account at anytime by logging in.
        </p>
        <Button value="Log in" variant="primary" size="medium" class="w-full mt-24" href="/login" />
        <SitterTeamIllustration :width="96" :height="96" class="mx-auto mt-48 md:hidden" />
      </Card>
      <SitterTeamIllustration
        :width="96"
        :height="96"
        outlineColor="#D7D8D9"
        heartColor="#FF8BAF"
        class="hidden md:block z-1 h-auto md:w-272 lg:w-608"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';
import Card from '@/components/card/Card.vue';
import SitterTeamIllustration from '@/graphics/illustrations/SitterTeamIllustration.vue';

export default {
  name: 'ConfirmDeactivation',
  components: { Button, Card, SitterTeamIllustration },
  computed: {
    hasActiveIapSubscription(): boolean {
      return sessionStorage.getItem('account_type') === 'premium_iap';
    },
    hasPremiumWebSubscription(): boolean {
      return sessionStorage.getItem('account_type') === 'premium_web';
    },
  },
  mounted() {
    sessionStorage.removeItem('account_type');
    sessionStorage.removeItem('show_confirmation_page');
  },
};
</script>
